import React, { useState, useEffect } from 'react';
import FilterType from './filter-type';
import FilterComp from './filter-comp';
import GTMDataLayer from './gtm';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

const Filters = (props) => {
  const [range, setRange] = useState([0, 1000]);
  const [max, setMax] = useState(1000);

  useEffect(() => {
    // Change default max 1000 to the max value from the data.
    if (props.dataFilters) {
      setRange([0, parseInt(props.dataFilters.max_kw)]);
      setMax(parseInt(props.dataFilters.max_kw));
    };    
  }, [props.dataFilters]);

  
  const handleTypeFilter = (e) => {
    props.setFilters({...props.filters, type: e.target.value});
    
    // Track type changes.
    GTMDataLayer({
      event: 'compatibility_filter_type',
      pageUrl: location.href,
      filter_type: e.target.value
    });
  };

  const handleCompFilter = (e) => {
    e.checked = true;
    props.setFilters({...props.filters, comp: e.target.value});
    
    // Track compatibility changes.
    GTMDataLayer({
      event: 'compatibility_filter_comp',
      pageUrl: location.href,
      filter_comp: e.target.value
    });
  }

  const handleRange = (val) => {
    setRange(val);
  }

  const handleStopDrag = () => {
    props.setFilters({...props.filters, kw: range});

    // Track compatibility changes.
    GTMDataLayer({
      event: 'compatibility_filter_power',
      pageUrl: location.href,
      filter_comp: range.join("-")
    });
  }

  const showRange = () => {
    document.querySelector('.filter-range-value').classList.add('show-range');
  }

  const clearFilters = (e) => {
    e.preventDefault();
    setRange([0, max]);
    document.querySelector('.filter-range-value').classList.remove('show-range');
    props.setFilters({...props.filters, type: 'All', comp: 'All', kw: [0, max]});
  }

  return (
    <div className='filters-container'>
      <div className='filter-clear'>
        <a href='#' className="small" onClick={clearFilters}>{Drupal.t('Clear filters')}</a>
      </div>

      {(props.dataFilters && Object.entries(props.dataFilters.type).length > 0) && (
        <div className='filter-type'>
        <h3 className='filter-label'>{Drupal.t('Filter')}</h3>
          <h4>{Drupal.t('Type')}</h4>
          <FilterType types={props.dataFilters.type} filters={props.filters} handleTypeFilter={handleTypeFilter} />
        </div>
      )}
{/* 
      {(props.dataFilters && Object.entries(props.dataFilters.comp).length > 0) && (
        <div className='filter-comp'>
          <h4>{Drupal.t('Region')}</h4>
          <FilterComp compSet={props.dataFilters.comp} filters={props.filters} handleCompFilter={handleCompFilter} />
        </div>
      )} */}

      <div className='filter-range'>
        <h4 className='justify-between grid-cell--center'>
          {Drupal.t('Max Power kW')}
          <span className='filter-range-value small'>{range[0]} - {range[1]}</span>
        </h4>
        <RangeSlider 
          min={0}
          max={max}
          defaultValue={range}
          step='10'
          value={range}
          onInput={handleRange}
          onThumbDragEnd={handleStopDrag}
          onRangeDragEnd={handleStopDrag}
          onThumbDragStart={showRange} />
      </div>

    </div>
  );
};

export default Filters;